import {ICloudflareStreamVideoConfig} from './ICloudflareStreamVideo';

import AbstractVideo from '../video/AbstractVideo';
import {TAspectRatioResponse} from '../video/IAbstractVideo';
import {fetch} from '../../utils/utils';
import {getAppOrigin} from '../../utils/url';

/**
 * Represents CloudflareStreamVideo
 */
class CloudflareStreamVideo extends AbstractVideo {
	/**
	 * Constructor
	 * @constructor
	 * @param {ICloudflareStreamVideoConfig} config - config
	 */
	constructor(config: ICloudflareStreamVideoConfig) {
		super({
			videoId: config.videoId,
			aspectRatio: config.aspectRatio,
			thumbnail: config.thumbnail,
		});
	}

	/**
	 * Returns the Cloudflare Stream video url
	 * @returns {string}
	 */
	getVideoUrl(): string {
		return `https://iframe.videodelivery.net/${this.videoId}`;
	}

	/**
	 * Returns the thumbnail url
	 * @param {object} dims - the dimensions to pass to Cloudflare Stream API
	 * @returns {string}
	 */
	getThumbnailUrl(dims: Record<string, number> = {height: 0, width: 0}): string {
		if (this.thumbnail) {
			return this.thumbnail;
		}

		const {height = 0, width = 0} = dims;
		let url = `${getAppOrigin()}/mobify/cloudflare-video/thumbnail?videoId=${this.videoId}`;

		if (height && width) {
			url += `&height=${height}&width=${width}`;
		}

		return url;
	}

	/**
	 * Returns the original dimensions of the video selected by id
	 * @param {string} id - the id of the video
	 * @returns {TAspectRatioResponse}
	 */
	static async staticGetOriginalAspectRatio(id: string): Promise<TAspectRatioResponse> {
		return await fetch(`${getAppOrigin()}/mobify/cloudflare-video/aspect-ratio?videoId=${id}`).then((res) =>
			(res as Response).json(),
		);
	}
}

export default CloudflareStreamVideo;
